<template lang="pug">
#bloco-inserir-territorio-certificacao
    h1 Inserir dados do território para análise de certificação manualmente
    el-card
        .box-card-inserir-territorio-manual
            .box-card-inserir-territorio-manual__conteudo
                .box-card-inserir-territorio-manual__conteudo__bloco
                    span Pesquise pelo território para adicionar à lista.

                el-alert(type='info', show-icon, :closable='false')
                    | Para CPF/CNPJ digite todos os números

                .box-card-inserir-territorio-manual__conteudo__bloco
                    el-form.box-card-inserir-territorio-manual__conteudo__bloco_pesquisa(
                        label-position='top',
                        :model='formularioCadastroCertificacao',
                        :rules='formularioCadastroCertificacaoRegras',
                        ref='formularioCadastroCertificacao'
                    )
                        .box-card-inserir-territorio-manual__conteudo__bloco_pesquisa-por-territorio
                            el-form-item(prop='territorioSelecionado')
                                template(slot='label')
                                    span Pesquise por território

                                el-select.input-territorio(
                                    v-model='formularioCadastroCertificacao.territorioSelecionado',
                                    :loading='buscandoTerritorio',
                                    :loading-text='textoBuscandoTerritorio',
                                    filterable,
                                    remote,
                                    allow-create,
                                    default-first-option,
                                    clearable,
                                    @clear='limparTerritorios',
                                    reserve-keyword,
                                    placeholder='Busque por nome do território, CAR, CPF ou CNPJ',
                                    remote-show-suffix,
                                    :remote-method='debouncedFetchTerritorios',
                                    @keydown.native.enter='validarTerritorio'
                                )
                                    el-option(
                                        v-for='territorio in territorios',
                                        :key='territorio.idTerritorio',
                                        :label='territorio.codigoCar',
                                        :value='territorio'
                                    )
                                        .input-pesquisa-por-territorio-select
                                            span {{ territorio.nomeTerritorio }}
                                            span.direita {{ 'CAR: ' + territorio.codigoCar + '' }}
                                    template(
                                        v-if='inputValue.length >= 3 && territorios === null && !buscandoTerritorio',
                                        #empty
                                    )
                                        .inserir-territorio-manual-sem-resultado(
                                            v-if='!verificarCar(inputValue)'
                                        )
                                            p Nenhum resultado encontrado.

                                        .inserir-territorio-manual-sem-resultado-cadastro-car

                .box-card-inserir-territorio-manual__conteudo__bloco_alerta_cadastro_territorio

                .box-card-inserir-territorio-manual__conteudo__bloco.alinhar-rigth
                    .box-card-inserir-territorio-manual__conteudo__bloco__buttons
                        el-button#adicionar-territorio-lista(
                            type='primary',
                            icon='el-icon-plus',
                            @click.prevent='validarTerritorio'
                        ) Enviar para processamento
</template>

<script>
import CarUtils from '@/utils/CarUtils';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import CertificacaoService from '@/services/CertificacaoService';
import debounce from 'lodash/debounce';

export default {
    name: 'BlocoInserirManualmenteCertificacao',
    components: {},
    props: {
        tiposCertificaoesSelecionadas: {
            type: Array,
            required: true
        }
    },
    data() {
        const validardorTerritorio = (rule, value, callback) => {
            const car = this.formularioCadastroCertificacao.carDigitado;

            if (!car || car.trim() === '') {
                return callback(new Error('Valor inválido. VAZIO'));
            }

            // Se digitou algo (CAR ou território), é válido
            callback();
        };

        return {
            formularioCadastroCertificacao: {
                carDigitado: '',
                territorioSelecionado: ''
            },
            formularioCadastroCertificacaoRegras: {
                carDigitado: [
                    {
                        trigger: 'change',
                        validator: validardorTerritorio
                    }
                ]
            },

            territorios: [],
            buscandoTerritorio: true,
            inputValue: '',
            textoBuscandoTerritorio: 'Mínimo 3 caracteres',
            debouncedFetchTerritorios: debounce(this.fetchTerritorios, 500)
        };
    },

    watch: {
        'formularioCadastroCertificacao.territorioSelecionado'(valor) {
            if (valor && valor.codigoCar) {
                this.formularioCadastroCertificacao.carDigitado = valor.codigoCar;
                return;
            }

            if (typeof valor === 'string') {
                this.formularioCadastroCertificacao.carDigitado = valor;
            }
        }
    },

    methods: {
        async fetchTerritorios(filtro) {
            this.buscandoTerritorio = true;

            if (filtro.length < 3) {
                this.textoBuscandoTerritorio = 'Mínimo 3 caracteres';
                this.territorios = [];
                this.formularioCadastroCertificacao.carDigitado = filtro;
                this.buscandoTerritorio = false;
                return;
            }

            this.textoBuscandoTerritorio = 'Carregando...';
            this.inputValue = filtro;
            this.formularioCadastroCertificacao.carDigitado = filtro;

            try {
                const { data } =
                    await ContratoOriginacaoServiceSubEmpresa.buscarTerritorioFiltro(
                        filtro
                    );

                if (CarUtils.isCar(filtro) && !data.length) {
                    // Não encontrou território → mantém apenas o CAR digitado
                    this.territorios = [];
                    this.formularioCadastroCertificacao.territorioSelecionado = null;
                } else {
                    this.territorios = data;
                }
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao buscar dados de território.'
                });
            } finally {
                this.buscandoTerritorio = false;
            }
        },
        verificarCar(valor) {
            return CarUtils.isCar(valor);
        },

        limparTerritorios() {
            this.territorios = [];
        },

        validarTerritorio() {
            this.$refs['formularioCadastroCertificacao'].validate(valid => {
                if (valid) {
                    this.enviarParaProcessamento();
                } else {
                    return false;
                }
            });
        },

        async enviarParaProcessamento() {
            const territorioSelecionado =
                this.formularioCadastroCertificacao.territorioSelecionado;

            const input = {
                car: this.formularioCadastroCertificacao.carDigitado,
                idTerritorio:
                    territorioSelecionado &&
                    typeof territorioSelecionado === 'object' &&
                    territorioSelecionado.idTerritorio
                        ? Number(territorioSelecionado.idTerritorio)
                        : null,
                idsTiposCertificacoes: this.tiposCertificaoesSelecionadas
            };

            try {
                await CertificacaoService.inserirManual(input);
                this.$notify.success({
                    message: 'Território inserido com sucesso.'
                });
            } catch (error) {
                if (error?.response?.data?.status === 400) {
                    this.$notify.error({
                        message: error?.response?.data?.message
                    });
                } else {
                    this.$notify.error({
                        message: 'Erro ao inserir território.'
                    });
                }
            } finally {
                this.$refs['formularioCadastroCertificacao'].resetFields();
                this.formularioCadastroCertificacao.carDigitado = '';
                this.formularioCadastroCertificacao.territorioSelecionado = null;
            }
        }
    }
};
</script>

<style lang="scss">
#bloco-inserir-territorio-certificacao {
    width: 100%;

    h1 {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }

    .el-card.is-always-shadow {
        min-height: 375px;
    }

    el-card {
        margin-top: 10px;
        display: flex;
    }

    .box-card-inserir-territorio-manual {
        height: 333px;
    }

    .box-card-inserir-territorio-manual__conteudo {
        display: flex;
        flex-direction: column;
        align-content: space-around;
        min-height: 325px;
        justify-content: space-between;

        .box-card-inserir-territorio-manual__conteudo__bloco {
            margin-bottom: 15px;
            display: flex;
            font-size: 16px;
            justify-content: flex-start;
            &.alinhar-rigth {
                justify-content: flex-end;
            }

            .box-card-inserir-territorio-manual__conteudo__bloco__buttons {
                display: flex;
                justify-content: flex-end;
                gap: 15px;
            }
        }
        .el-alert .el-alert__description {
            margin: 0 0 0 0;
        }
    }

    .box-card-inserir-territorio-manual__conteudo__bloco_pesquisa {
        flex-direction: row;
        display: flex;
        justify-content: space-between;
        gap: 15px;
        width: 100%;

        .box-card-inserir-territorio-manual__conteudo__bloco_pesquisa-por-territorio {
            display: flex;
            flex-direction: column;

            input {
                width: 661px;
            }
        }
    }
}
.inserir-territorio-manual-sem-resultado {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 5px;
    text-align: center;
    justify-content: center;
    p {
        padding: 0;
        margin-top: 7px;
        margin-bottom: 5px;
    }
    .btn-cadastro {
        border-radius: 20px !important;
        color: #000000;
    }
}
.el-select-dropdown.el-popper
    > .inserir-territorio-manual-sem-resultado-cadastro-car,
.inserir-territorio-manual-sem-resultado-cadastro-car + .popper__arrow {
    display: none !important;
    min-width: 0px !important;
}

.el-select-dropdown.el-popper {
    margin-top: 25px;
}

.input-pesquisa-por-territorio-select {
    display: flex;
    gap: 10px;
    justify-content: space-between;

    .direita {
        font-size: 10px;
        color: #8492a6;
    }
}
</style>
